import {
  CardData,
  CardPaymentPayload,
  CardPaymentResponse,
  EncryptedCardData,
  ICardHandler,
  OtpAuthPayload,
  PinAuthPayload,
} from '../types';
import { encryptCardDetails, importBase64PublicKey } from 'utils/encryption';
import axiosInstance from 'utils/axiosInstance';

export class PayStackCardHandler implements ICardHandler {
  async encryptCardData(
    cardData: CardData,
    publicKey: string,
  ): Promise<EncryptedCardData> {
    const expMonth = cardData.expirationDate.split('/')[0];
    const expYear = cardData.expirationDate.split('/')[1];

    const key = importBase64PublicKey(publicKey);
    return encryptCardDetails(key, {
      cvv: cardData.cvv,
      number: cardData.cardNumber,
      expiryMonth: expMonth,
      expiryYear: expYear,
    }) as unknown as EncryptedCardData;
  }

  async processPayment(
    payload: CardPaymentPayload,
  ): Promise<CardPaymentResponse> {
    const response = await axiosInstance.post('/payments', payload);
    return response.data;
  }

  async processOtp(payload: OtpAuthPayload) {
    const response = await axiosInstance.post('/payments/otpAuths', payload);
    return response.data;
  }

  async processPin(payload: PinAuthPayload) {
    const response = await axiosInstance.post('/payments/pinAuths', {
      pin: payload.pin,
      reference: payload.reference,
    });

    return response.data;
  }

  async processVisaPayment(
    payload: CardPaymentPayload,
  ): Promise<CardPaymentResponse> {
    throw new Error(
      'Visa payment processing is not supported by PayStackCardHandler.',
    );
  }
}
